import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoItsFor() {
  return <section className="w-full bg-[#0f1419] py-16 md:py-24 px-4" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-12 text-center" data-id="element-222">
          Para quién es (y para quién no)
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-223">
          {/* Esto es para ti si */}
          <div className="bg-[#1e2738] rounded-2xl p-8 shadow-lg shadow-black/20 ring-1 ring-[#e76f51]/10" data-id="element-224">
            <div className="flex items-center gap-3 mb-6" data-id="element-225">
              <div className="w-10 h-10 bg-[#e76f51] rounded-full flex items-center justify-center shadow-lg shadow-[#e76f51]/20" data-id="element-226">
                <CheckIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-227" />
              </div>
              <h3 className="text-2xl font-bold text-[#e8edf4]" data-id="element-228">
                Esto es para ti si:
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-229">
              <li className="flex items-start gap-3" data-id="element-230">
                <span className="text-[#a8b5d1] mt-1" data-id="element-231">•</span>
                <span className="text-lg text-[#d1d9e6]" data-id="element-232">
                  eres mujer (23–55) y en el día "puedes con todo", pero en la
                  noche se te prende la mente
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-233">
                <span className="text-[#a8b5d1] mt-1" data-id="element-234">•</span>
                <span className="text-lg text-[#d1d9e6]" data-id="element-235">
                  despiertas a medianoche y te vas en espiral
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-236">
                <span className="text-[#a8b5d1] mt-1" data-id="element-237">•</span>
                <span className="text-lg text-[#d1d9e6]" data-id="element-238">
                  quieres algo práctico, corto, sin exposición, sin terapia
                  complicada
                </span>
              </li>
            </ul>
          </div>

          {/* No es para ti si */}
          <div className="bg-[#2a3447] rounded-2xl p-8 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-239">
            <div className="flex items-center gap-3 mb-6" data-id="element-240">
              <div className="w-10 h-10 bg-[#1a1f2e] rounded-full flex items-center justify-center ring-1 ring-[#a8b5d1]/30" data-id="element-241">
                <XIcon className="w-6 h-6 text-[#a8b5d1]" aria-hidden="true" data-id="element-242" />
              </div>
              <h3 className="text-2xl font-bold text-[#e8edf4]" data-id="element-243">
                No es para ti si:
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-244">
              <li className="flex items-start gap-3" data-id="element-245">
                <span className="text-[#a8b5d1] mt-1" data-id="element-246">•</span>
                <span className="text-lg text-[#d1d9e6]" data-id="element-247">
                  buscas promesas médicas o "cura"
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-248">
                <span className="text-[#a8b5d1] mt-1" data-id="element-249">•</span>
                <span className="text-lg text-[#d1d9e6]" data-id="element-250">
                  estás en crisis severa y necesitas atención clínica inmediata
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}